import { CATEGORY, CATEGORY_DESCRIPTION, ERROR_MESSAGES, LEVELNAME, LEVEL_LIST, QUANTITY_LIST_ECOLIER, QUANTITY_LIST_OTHER, TIMER } from "../utils/constants";
import { CapitalizeTitle, CreateIconStyled, IconHexagon, IconStar, IconStarOutline, InfoDeleteQuiz, ItemOption, LevelStyled, NewInfo, PaperStyled, QuantityStyled, SpinnerBtn, SubTitle, TextItem, TimerStyled, Title, WrapperCreator, WrapperNotification, WrapperOptionStyled } from "./CategoryCreateQuiz.styled";
import { Button} from "@mui/material";
import { useEffect, useState } from "react";
import { useCreateQuiz } from "../hooks/useCreateQuiz";
import { createQuizFn } from "../utils/createQuizFn";
import { toast } from 'react-hot-toast';
import { CreateQuizPopup } from "./modals/CreateQuizPopup";
import { Link, useParams } from "react-router-dom";
import { useTheme } from "@emotion/react";



export const CreateQuizNotRegister = () => {
    const { category } = useParams();    
    const theme = useTheme();
    
    const { createQuiz, isCreating } = useCreateQuiz();

    const [allQuestions, setAllQuestions] = useState([]);
    const [quantity, setQuantity] = useState(null);
    const [level, setLevel] = useState(null);    
    const [isActiveTimer, setIsActiveTimer] = useState(null);
    const [idQuiz, setIdQuiz] = useState(null);
    const [isOpenPopup, setIsOpenPopup] = useState(false); 

    useEffect(() => {               
        const getQuizzes = async () => {
            try {
                const quizzes = await import(`../utils/${category}Tasks.json`);
                if (quizzes?.default) {
                    setAllQuestions(quizzes.default);
                }
            } catch (error) {
                toast.error(ERROR_MESSAGES[404], { duration: 6000 });
            } 
        }        
        if (category) {
            getQuizzes();           
        }
    }, [category]);
    
   
    const handleCleanInfoCreatedQuiz = () => {
        setQuantity(null);
        setLevel(null);
        setIsActiveTimer(null);
        setIdQuiz(null);
    }

    const handleClosePopup = () => {
        setIsOpenPopup(false);
        handleCleanInfoCreatedQuiz();
    }

    const helperCreateQuiz = async questions => {
        if (questions.length === 0) {
            toast.error(ERROR_MESSAGES[404], { duration: 6000 });
            return;
        };       
        const quiz = {
            category,
            level,
            tasks: questions,
            timer: isActiveTimer? TIMER[`QUANTITY_${quantity}`]: 0,
        };
        const response = await createQuiz(quiz);
        if (response) {
            setIdQuiz(response);
            setIsOpenPopup(true);            
            return response;
        }
    }

    
    const handleCreateQuiz = async () => {
         if (!quantity || !level || isActiveTimer === null) {            
             toast(`Scegli: ${!quantity? '~la quantità dei quesiti;':''} ${!level? '~il livello di difficoltà;':''} ${isActiveTimer===null ? '~se azionare il timer oppure no;':''}`, {
                icon: '⚠️',
                duration: 6000,
            });
             return;
        }
        const createdQuestions = createQuizFn({ allQuestions, quantity, level, resolvedQuizzes: [] });
        await helperCreateQuiz(createdQuestions); 
    }

    return (
        <>
            {isOpenPopup &&
                <CreateQuizPopup
                    isOpenPopup={isOpenPopup}
                    onClosePopup={handleClosePopup}       
                    infoQuiz={{
                    category,
                    quantity,
                    level,
                    timer: isActiveTimer? TIMER[`QUANTITY_${quantity}`]: 0,
                    idQuiz,
                }}                             
                />}
            <WrapperCreator>
                    <Title>
                        <span>Crea quiz</span>
                        <p><CapitalizeTitle>{category}: </CapitalizeTitle><span>{CATEGORY_DESCRIPTION[category]}</span></p>
                </Title>
                <WrapperNotification elevation={3}>
                        <NewInfo>Perché registrarsi su mathlab.it?</NewInfo>
                        <ul>
                            <ItemOption><IconHexagon/><TextItem><b>Quiz sempre nuovi:</b> niente domande ripetute</TextItem></ItemOption>
                            <ItemOption><IconHexagon/><TextItem><b>Progressi salvati:</b> tieni traccia delle tue risposte</TextItem></ItemOption>
                            <ItemOption><IconHexagon/><TextItem><b>Statistiche:</b> monitora il tuo coefficiente di prestazioni</TextItem></ItemOption>
                    </ul>
                    <Button color='benjamin' variant='contained' component={Link} to='/register'>registrati</Button>
                    </WrapperNotification>
                    <InfoDeleteQuiz>I quiz personalizzati saranno disponibili per <b>15 giorni</b></InfoDeleteQuiz>
                    <PaperStyled elevation={3}>
                        <SubTitle>Quanti quesiti vuoi avere nel Quiz?</SubTitle>
                        <WrapperOptionStyled>
                            {category === CATEGORY.ECOLIER && QUANTITY_LIST_ECOLIER.map(quantityObj => {
                                return (
                                    <QuantityStyled
                                    key={quantityObj.quantity}
                                    category={category}
                                    onClick={() => setQuantity(quantityObj.quantity)}
                                    style={{
                                        backgroundColor: quantity === quantityObj.quantity && `${theme.palette[category].main}`,
                                        color: quantity === quantityObj.quantity && `${theme.palette.text.light}`
                                    }}>                            
                                        {quantityObj.quantity}
                                    </QuantityStyled>);
                            })}
                            {category !== CATEGORY.ECOLIER && QUANTITY_LIST_OTHER.map(quantityObj => {
                                return (
                                    <QuantityStyled
                                        key={quantityObj.quantity}
                                        category={category}
                                        onClick={() => setQuantity(quantityObj.quantity)}
                                        style={{
                                            backgroundColor: quantity === quantityObj.quantity && `${theme.palette[category].main}`,
                                            color: quantity === quantityObj.quantity && `${theme.palette.text.light}`
                                        }}>
                                        {quantityObj.quantity}
                                    </QuantityStyled>);
                            })}
                        </WrapperOptionStyled>
                    </PaperStyled>   
            

            <PaperStyled elevation={3}>
                <SubTitle>Personalizza la difficoltà</SubTitle> 
                <WrapperOptionStyled>
                    {LEVEL_LIST.map(levelObj => {
                        return (
                            <LevelStyled
                                key={levelObj.level}
                                category={category}
                                onClick={() => setLevel(levelObj.level)}
                                style={{
                                    backgroundColor: level === levelObj.level && `${theme.palette[category].main}`,
                                    color: level === levelObj.level && `${theme.palette.text.light}`
                                }}> 
                                {(levelObj.level === LEVELNAME.ELEMENTARY) && <><IconStar /><IconStarOutline/><IconStarOutline/></>}
                                {(levelObj.level===LEVELNAME.MEDIUM) && <><IconStar/><IconStar/><IconStarOutline/></>}
                                {(levelObj.level===LEVELNAME.HARD) && <><IconStar/><IconStar/><IconStar /></>}
                                {(levelObj.level===LEVELNAME.STANDARD) && 'mix'}
                                
                            </LevelStyled>)
                    })}
                </WrapperOptionStyled>           
            </PaperStyled>


            <PaperStyled elevation={3}>
                <SubTitle>Timer</SubTitle> 
                <WrapperOptionStyled>                    
                    <TimerStyled
                        category={category}
                        onClick={() => setIsActiveTimer(true)} 
                        style={{
                                    backgroundColor: isActiveTimer && `${theme.palette[category].main}`,
                                    color: isActiveTimer && `${theme.palette.text.light}`
                                }}
                    >
                        {(!quantity || !isActiveTimer) && 'on'}
                        {(quantity && isActiveTimer) && `${TIMER[`QUANTITY_${quantity}`]}'`}
                    </TimerStyled>
                    <TimerStyled
                        category={category}
                        onClick={() => setIsActiveTimer(false)}
                        style={{
                                    backgroundColor: isActiveTimer===false && `${theme.palette[category].main}`,
                                    color: isActiveTimer===false && `${theme.palette.text.light}`
                                }}
                    >
                        off
                    </TimerStyled>                 
                </WrapperOptionStyled>           
            </PaperStyled>


            <Button variant="contained" color={category} onClick={handleCreateQuiz} disabled={isCreating}>
                crea quiz
                        {isCreating && <SpinnerBtn size={16} />}
                        {!isCreating && <CreateIconStyled/>}
                    </Button> 

        </WrapperCreator>
        </>
        
        
    )
};